<template>
    <div>
        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h2 class="text-left mb-0">{{ $t('recordsAndTotal.vendors') }}
            </h2>
            <div class="d-flex justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="showMaintenaceModal()" v-if="allowAddData"
                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                    variant="primary">
                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white">{{ $t('recordsAndTotal.addVendor') }}</p>
                </b-button>
            </div>
        </div>
        <div class="data-table team-data-table bg-white rounded table-custom-border">
            <div class="bg-white rounded pt-3 pt-sm-4">
                <div class="table_row">
                    <div>
                        <div class="filter-box" v-if="isTableMounted">
                            <div class="d-flex mb-4 px-3 px-sm-4">
                                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                    <b-input-group class="username-input-field">
                                        <b-form-input type="text" :placeholder="$t('maintenanceShared.search')"
                                            v-model="filterFields.search" class="unit f-12"
                                            @keyup.enter="getVendors()"></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="primary" @click="getVendors()">
                                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                        stroke="white" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </div>
                        <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 180px); overflow: hidden;">
                            <b-skeleton-table :rows="17" :columns="7"
                                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                        </div>
                        <b-table v-else ref="tableRef" class="mt-2" responsive :fields="translatedFields" :items="items"
                            hover :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                            :no-local-sorting="true" :busy.sync="isBusy" :sticky-header="'calc(100vh - 280px)'"
                            :show-empty="emptyTable">
                            <template #cell(address)="data">
                                <span>{{ data.value ? data.value : '-' }}</span>
                            </template>
                            <template #cell(city)="data">
                                <span>{{ data.value ? data.value : '-' }}</span>
                            </template>
                            <template #cell(zip)="data">
                                <span>{{ data.value ? data.value : '-' }}</span>
                            </template>
                            <template #cell(phone)="data">
                                <span>{{ data.value ? data.value : '-' }}</span>
                            </template>
                            <template #cell(email)="data">
                                <span>{{ data.value ? data.value : '-' }}</span>
                            </template>
                            <template #cell(state)="data">
                                <span>{{ data.value ? getStateLabel(data.value) : '-' }}</span>
                            </template>
                            <template #cell(action)="data">
                                <div v-if="allowUpdateVendors || allowDeleteVendors">
                                    <svg @click="editVendorItem(data.item)" v-if="allowUpdateVendors"
                                        class="mr-4 cursor-pointer" width="18" height="18" viewBox="0 0 18 18" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                            fill="#2CCE89" />
                                    </svg>
                                    <svg @click="showVendorDeletePopup(data.item.id)" v-if="allowDeleteVendors"
                                        class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <span v-else> - </span>
                            </template>
                        </b-table>
                        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                            <div class="d-flex align-items-center flex-wrap">
                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                </div>
                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                                <div class="pagination">
                                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                        aria-controls="my-table"></b-pagination>
                                </div>
                            </div>
                        </div>
                        <AddandUpdateVendor :allowAddData="allowAddData" :editVendor="editVendor" :data="vendorPayload"
                            :vendorID="vendorID" @updateVendorList="getVendors"
                            @close="vendorID = null; $emit('close'); editVendor = false" :states="states" />
                        <DeleteModal v-if="showDeletePopup" @confirm="deleteItem($event)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteModal from "@/components/DeleteModal.vue";
import { checkEmail, checkPhoneFormat } from '../../services/helper';
import AddandUpdateVendor from './AddandUpdateVendor.vue';
export default {
    name: "Vendors",
    props: ['allowAddVendor'],
    components: { DeleteModal, AddandUpdateVendor },
    data() {
        return {
            checkEmail,
            checkPhoneFormat,
            filterFields: {
                search: ""
            },
            vendorPayload: {
                name: "",
                address: "",
                city: "",
                state: 54,
                zip: "",
                phone: "",
                email: ""
            },
            vendorID: null,
            sortDesc: undefined,
            sortBy: undefined,
            perPage: 25,
            states: [],
            showDeletePopup: false,
            items: [],
            currentPage: 1,
            positionText: "",
            rows: 0,
            isBusy: false,
            isTableMounted: false,
            emptyTable: false,
            editVendor: false,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    computed: {
        ...mapGetters(["rolePermissions", "userCompany", "vendors", "allCountries"]),
        translatedFields() {
            return [
                { key: "name", label: this.$t('maintenanceVendors.columnName'), stickyColumn: true, sortable: true, thClass: 'font-table-weight-bold' },
                { key: "address", label: this.$t('maintenanceVendors.columnAddress'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "city", label: this.$t('maintenanceVendors.columnCity'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "state", label: this.$t('maintenanceVendors.columnState'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "zip", label: this.$t('maintenanceVendors.columnZip'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "phone", label: this.$t('maintenanceVendors.columnPhone'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "email", label: this.$t('maintenanceVendors.columnEmail'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        allowUpdateVendors() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][1].allow
        },
        allowDeleteVendors() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][3].allow
        },
        allowAddData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][2].allow
        },
    },
    watch: {
        allowAddVendor() {
            if (this.allowAddVendor) {
                this.$bvModal.show('modal-vendor')
            }
        },
        perPage: {
            async handler() {
                await this.getVendors();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getVendors();
            },
        },
        sortBy: {
            async handler() {
                await this.getVendors();
            },
        },
        sortDesc: {
            async handler() {
                await this.getVendors();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        }
    },
    methods: {
        ...mapActions([
            "getAllVendors",
            "setNotification",
            "updateVendor",
            "addVendor",
            "deleteVendor",
            "getAllCountries"
        ]),
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async deleteItem(status) {
            if (status) {
                try {
                    await this.deleteVendor(`${this.vendorID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('maintenanceVendors.vendorDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.vendorID = null
                    this.showDeletePopup = false;
                    await this.getVendors()
                }
                catch (e) {
                    console.log(e)
                }
            }
            else this.showDeletePopup = false
        },
        editVendorItem(data) {
            this.editVendor = true
            this.vendorPayload = data
            this.vendorID = data.id
            this.$bvModal.show('modal-vendor')
        },
        showVendorDeletePopup(id) {
            this.showDeletePopup = true;
            this.vendorID = id;
        },
        async getVendors() {
            try {
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] !== '') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=name&sort_order=desc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getAllVendors(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('maintenanceShared.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('maintenanceShared.emptyPosition')
                }
                this.items = [];
                this.vendors.map((vendor) => {
                    this.items.push({
                        id: vendor.id,
                        name: vendor.name,
                        address: vendor.address,
                        city: vendor.city,
                        state: vendor.state,
                        zip: vendor.zip,
                        phone: vendor.phone,
                        email: vendor.email
                    })
                })
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },
        async getCountries() {
            await this.getAllCountries();
            this.countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates();
        },
        getStates() {
            if (this.allCountries && this.allCountries.length > 0 && this.allCountries[0].state) {
                this.states = this.allCountries[0].state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            } else {
                this.states = [];
            }

            if (this.states.length === 0) {
                this.vendorPayload.state = null;
            } else {
                if (this.vendorPayload.state) {
                    const defaultState = this.states.find((state) => state.label === "-");
                    if (defaultState) {
                        this.vendorPayload.state = defaultState.id;
                    }
                }
            }
        },
        getStateLabel(state) {
            const foundState = this.states.find(item => item.id === state);
            return foundState ? foundState.label : '-';
        },
    },
    async mounted() {
        await this.getCountries()
    }
}
</script>